import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as SurveyStore from '../../store/Survey';
import getLangTranslation from '../../common/lang-trans';
import { RouteComponentProps } from 'react-router';

type SurveyProps =
  SurveyStore.DataState
  & typeof SurveyStore.actionCreators
  & RouteComponentProps<{ }>;

class SurveyLanguage extends React.PureComponent<SurveyProps> {
    public render() {
        // const language = this.props.language || 'en';
        // const langTrans = getLangTranslation(language);
        const langTransEN = getLangTranslation('en');
        const langTransFR = getLangTranslation('fr');

        return (
            <React.Fragment>
                <div className="row g-3" >
                    <div className="col-sm-12">
                        <label className="fw-bold">{ langTransEN.SelectLanguage } / { langTransFR.SelectLanguage }:</label>
                    </div>
                    <div className="col-sm-12">
                        <button className="btn btn-primary" onClick={ () => this.props.SetLanguage('en', true) }>{ langTransFR.OtherLang }</button>
                        <button className="btn btn-primary" onClick={ () => this.props.SetLanguage('fr', true) }>{ langTransEN.OtherLang }</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default connect(
    (state: ApplicationState) => state.surveyStore,
    SurveyStore.actionCreators
)(SurveyLanguage as any);
